import {Client} from '@fiizy/auth'
import clientData from "./clientData";

export default new Client({
    apiUrl: app.config.apiUrl,
    clientData
})
